import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class FormatCartNote extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._noteElem = document.querySelector('[data-format-cart-note-input]')
  }

  mount () {
    this._elem.addEventListener('submit', e => {
      if (this._noteElem.value) {
        this._noteElem.value = this._noteElem.value.replaceAll('\n', ' ').replaceAll('\r', ' ')
      } 
    })

    this._noteElem.addEventListener('input', e => {
      this._noteElem.value = this._noteElem.value.replaceAll(/[\~\@\*\|\}\[\]\{\}\&\@\|]/g, '')
    })
  }
}